import axios from 'axios'
import store from '@/store'

const DEV_API  = 'https://sophia.lxcor.com:8080/'
const PROD_API = 'https://api.calendula.lxcor.com/'

const baseURL = process.env.NODE_ENV === 'development' ? DEV_API : PROD_API

const client = axios.create({
    baseURL,
    headers: {
        // TODO: move to env var before production
        'Authorization': 'Bearer rwMHkjB-SZg9etmSsDSiZiwcYeK3eEt-keETFkg1'
    }
})

client.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 429) {
            store.commit('lockApi')
        }
        return Promise.reject(error)
    }
)

export default client
